<script lang="ts">
  import FavoriteIcon from "$lib/icons/FavoriteIcon.svelte";
  import {createEventDispatcher} from "svelte";
  import type {IGame} from "$lib/interfaces/IGame";
  import {gameService} from "$lib/services/game.service";
  import {openDialog} from "$lib/stores/dialogStores";
  import {user} from "$lib/stores";
  import type {IUser} from "$lib/interfaces/IUserMe";

  interface Props {
    game: IGame;
  }

  let { game }: Props = $props();
  let isFavorite = $state(game.isFavorite ?? false);
  const dispatch = createEventDispatcher();
  let userMe: IUser | null;

  user.subscribe(user => {
      userMe = user;
  })

  function favoriteClick() {
    if (!userMe) {
        openDialog('RegistrationModal')
        return;
    }
    isFavorite = !isFavorite;
    if (isFavorite) {
      gameService.addToFavorite(game.id).then((res) => {
        dispatch('favorite', isFavorite);
      });
    } else {
      gameService.deleteFromFavorites(game.id).then((res) => {
        dispatch('favorite', isFavorite);
      });
    }
  }
</script>

<button onclick={() => favoriteClick()}>
  <FavoriteIcon bind:isFavorite={isFavorite} />
</button>
